import moment from 'moment';
import { RECORD_TYPE } from './enums';
const processes = require('./processes');

export const processJydacomSalaryData = (
  reportData,
  settings,
  shadowProjectsMap,
  activeEmployerBusinessId
) => {
  const {
    workStartTime,
    workEndTime,
    records,
    automaticMealBreakReductionLengthHours,
  } = reportData;

  const getJydacomProjectNumber = (project) => {
    if (shadowProjectsMap && activeEmployerBusinessId && project?.id) {
      const shadowProjectId = `${project.id}_${activeEmployerBusinessId}`;
      const shadowProject = shadowProjectsMap[shadowProjectId];
      if (shadowProject?.jydacomWorksiteId) {
        return shadowProject.jydacomWorksiteId;
      }
    }
    return project?.jydacomWorksiteId || project?.projectKey;
  };

  const trimRecordsTime = () => {
    const filteredRecords = records.filter((record) => {
      // if (record.type && record.type.includes('ABSENCE')) {
      //   return true;
      // }

      const utcOffsetClockInAt = moment(record.clockInAt);

      const utcOffsetClockOutAt = moment(record.clockOutAt);

      const clockInMinutes =
        parseInt(utcOffsetClockInAt.format('HH')) * 60 +
        parseInt(utcOffsetClockInAt.format('mm'));

      const clockInAndClockOutMinuteDiff = utcOffsetClockOutAt.diff(
        utcOffsetClockInAt,
        'minutes',
        true
      );

      const clockOutTotalMinutes =
        clockInMinutes + clockInAndClockOutMinuteDiff;

      const workStartTimeMinutes =
        parseInt(workStartTime.split(':')[0]) * 60 +
        parseInt(workStartTime.split(':')[1]);

      const workEndTimeMinutes =
        parseInt(workEndTime.split(':')[0]) * 60 +
        parseInt(workEndTime.split(':')[1]);

      // If clockIn is after workEndTime or clockOut is before workStartTime, do nothing and return
      if (
        clockInMinutes < workEndTimeMinutes &&
        clockOutTotalMinutes > workStartTimeMinutes
      )
        return record;
    });

    const croppedRecords = filteredRecords.map((record) => {
      // if (record.type && record.type.includes('ABSENCE')) {
      //   record.croppedClockInAt = record.clockInAt;
      //   record.croppedClockOutAt = record.clockOutAt || record.clockInAt;
      //   return record;
      // }

      const utcOffsetClockInAt = moment(record.clockInAt);

      const utcOffsetClockOutAt = moment(record.clockOutAt);

      const clockInMinutes =
        parseInt(utcOffsetClockInAt.format('HH')) * 60 +
        parseInt(utcOffsetClockInAt.format('mm'));
      const clockOutMinutes =
        parseInt(utcOffsetClockOutAt.format('HH')) * 60 +
        parseInt(utcOffsetClockOutAt.format('mm'));

      const workStartTimeMinutes =
        parseInt(workStartTime.split(':')[0]) * 60 +
        parseInt(workStartTime.split(':')[1]);

      const workEndTimeMinutes =
        parseInt(workEndTime.split(':')[0]) * 60 +
        parseInt(workEndTime.split(':')[1]);

      if (clockInMinutes < workStartTimeMinutes) {
        record.croppedClockInAt = moment(record.clockInAt)
          .startOf('day')
          .add(workStartTimeMinutes, 'minutes')
          .toISOString();
      } else {
        record.croppedClockInAt = record.clockInAt;
      }
      if (clockOutMinutes > workEndTimeMinutes) {
        record.croppedClockOutAt = moment(record.clockOutAt)
          .startOf('day')
          .add(workEndTimeMinutes, 'minutes')
          .toISOString();
      } else {
        record.croppedClockOutAt = record.clockOutAt;
      }
      return record;
    });

    reportData.records = croppedRecords;
    return reportData;
  };

  const initDays = () => {
    const fromDate = moment(reportData.fromDate).utcOffset(
      reportData.utcOffset,
      false
    );
    const toDate = moment(reportData.toDate).utcOffset(
      reportData.utcOffset,
      false
    );

    let days = {};
    let i = fromDate;
    while (i.format('YYYY-MM-DD') <= toDate.format('YYYY-MM-DD')) {
      const day = i.format('YYYY-MM-DD');

      if (!(day in days)) {
        days[day] = {};
      }
      i.add(1, 'days');
    }
    reportData.days = days;

    return reportData;
  };

  const baseHours = () => {
    const records = reportData.records;
    let days = reportData.days;

    const { recordAllowancesGroupedByRecordId } = reportData;

    const recordsWithExistingResource = records.filter(
      (record) => record.resource
    );

    let sortedRecords = [];

    try {
      recordsWithExistingResource.sort((a, b) =>
        a.croppedClockInAt.localeCompare(b.croppedClockInAt)
      );
      if (settings.lastNameFirst) {
        sortedRecords = recordsWithExistingResource.sort((a, b) =>
          a.resource.lastName.localeCompare(
            b.resource.lastName,
            settings.language,
            { sensitivity: 'base' }
          )
        );
      } else {
        sortedRecords = recordsWithExistingResource.sort((a, b) =>
          a.resource.firstName.localeCompare(
            b.resource.firstName,
            settings.language,
            { sensitivity: 'base' }
          )
        );
      }
    } catch (err) {
      console.log('ERROR 1');
    }

    let resources = {};

    sortedRecords.forEach((record) => {
      let clockOut = null;
      if (record.croppedClockOutAt) {
        clockOut = new Date(record.croppedClockOutAt);
      }

      if (clockOut) {
        let endDay = moment(record.croppedClockOutAt)
          .utc()
          .utcOffset(reportData.utcOffset, false);
        let i = moment(record.croppedClockInAt)
          .utc()
          .utcOffset(reportData.utcOffset, false);

        while (i.format('YYYY-MM-DD') <= endDay.format('YYYY-MM-DD')) {
          const day = i.format('YYYY-MM-DD');

          if (Object.keys(days).includes(day)) {
            if (!(day in days)) {
              days[day] = {};
            }
            const resource = record.resource;
            if (!(resource.user in days[day])) {
              days[day][resource.user] = {
                hours: 0,
                reduction: 0,
                projectHours: {},
                assignmentHours: {},
                reductions: {
                  [RECORD_TYPE.BREAK_COFFEE]: 0,
                  [RECORD_TYPE.BREAK_MEAL]: 0,
                  [RECORD_TYPE.BREAK]: 0,
                  AUTOMATIC_MEAL_BREAK_REDUCTION: 0,
                },
              };
            }

            if (!(resource.user in resources)) {
              resources[resource.user] = {
                resource,
                totalHours: 0,
                days: {},
                totals: {},
                reductions: {},
                automaticReductions: 0,
                seperateAdditionalSalaries: [],
                additionalSalaries: {},
                additionalSalariesByProjectId: {},
                workedProjects: [],
                workedAssignments: [],
                dailyProjectsAtMealBreak: {},
                dailyAssignmentsAtMealBreak: {},
              };
              resources[resource.user].totals[RECORD_TYPE.ABSENCE] = 0;
              resources[resource.user].totals[RECORD_TYPE.ABSENCE_SICK_LEAVE] =
                0;
              resources[resource.user].totals[
                RECORD_TYPE.ABSENCE_VACATION_PAID
              ] = 0;
              resources[resource.user].totals[RECORD_TYPE.BENEFIT] = 0;
              resources[resource.user].totals[RECORD_TYPE.BREAK] = 0;
              resources[resource.user].totals[RECORD_TYPE.BREAK_COFFEE] = 0;
              resources[resource.user].totals[RECORD_TYPE.BREAK_MEAL] = 0;
              resources[resource.user].totals[RECORD_TYPE.WORK] = 0;
              resources[resource.user].totals[RECORD_TYPE.PROJECTWORK] = 0;
              resources[resource.user].reductions[RECORD_TYPE.WORK] = 0;
              resources[resource.user].reductions[RECORD_TYPE.PROJECTWORK] = 0;
              resources[resource.user].totals.reductionsByProject = {};
              resources[resource.user].totals.reductionsByAssignment = {};
            }
            if (!(day in resources[resource.user].days)) {
              resources[resource.user].days[day] = {
                hours: 0,
                reduction: 0,
              };
            }

            const co = moment.min(
              moment(record.croppedClockOutAt),
              moment(i).set({
                hours: 23,
                minute: 59,
                second: 59,
                millisecond: 999,
              })
            );
            const ci = moment.max(
              moment(record.croppedClockInAt),
              moment(i).set({
                hours: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
              })
            );
            const hours = co.diff(ci, 'hours', true);

            // count break record reductions for each project
            if (record.type.includes('BREAK')) {
              days[day][resource.user].reductions[RECORD_TYPE] += hours;

              // PROJECT HOURS LOGIC
              const existingCountedReductionsForProject =
                resources[resource.user].totals.reductionsByProject[
                  record.project.id
                ];

              if (!existingCountedReductionsForProject) {
                resources[resource.user].totals.reductionsByProject[
                  record.project.id
                ] = {
                  BREAK_MEAL: 0,
                  BREAK_COFFEE: 0,
                  BREAK: 0,
                  AUTOMATIC_MEAL_BREAK_REDUCTION: 0,
                };
              }
              resources[resource.user].totals.reductionsByProject[
                record.project.id
              ][record.type] += hours;

              if (!days[day][resource.user].projectHours[record.project.id]) {
                days[day][resource.user].projectHours[record.project.id] = {
                  hours: 0,
                  projectName: record.project.name,
                  reductions: {
                    BREAK_MEAL: 0,
                    BREAK_COFFEE: 0,
                    BREAK: 0,
                    AUTOMATIC_MEAL_BREAK_REDUCTION: 0,
                  },
                };
              }
              days[day][resource.user].projectHours[
                record.project.id
              ].reductions[record.type] += hours;
            }

            if (
              record.type === RECORD_TYPE.WORK ||
              record.type === RECORD_TYPE.PROJECTWORK
            ) {
              days[day][resource.user].hours += hours;

              const thisDayHoursExceed6Hours =
                days[day][resource.user].hours > 6;

              const isPreviouslyMadeAutomaticReductionsForDay =
                days[day][resource.user].reductions[
                  'AUTOMATIC_MEAL_BREAK_REDUCTION'
                ] > 0;

              if (thisDayHoursExceed6Hours) {
                days[day][resource.user].reduction =
                  automaticMealBreakReductionLengthHours;
                days[day][resource.user].reductions[
                  'AUTOMATIC_MEAL_BREAK_REDUCTION'
                ] = automaticMealBreakReductionLengthHours;
              }

              const recordAssignment = record.assignment
                ? record.assignment
                : undefined;

              const recordAssignmentId = recordAssignment
                ? recordAssignment.id
                : `withoutAssignment_${record.project.id}`;

              if (
                !days[day][resource.user].assignmentHours[recordAssignmentId]
              ) {
                days[day][resource.user].assignmentHours[recordAssignmentId] = {
                  hours: 0,
                  assignmentName: `${recordAssignment?.number || ''} ${
                    recordAssignment?.name || ''
                  }`,
                  assignmentId: recordAssignmentId,
                  assignmentNumber: recordAssignment?.number,
                  projectId: record.project.id,
                  projectName: record.project.name,
                  jydacomProjectNumber: getJydacomProjectNumber(record.project),
                  jydacomAssignmentCode: recordAssignment?.integrationNumber,
                  jydacomAssignmentId: recordAssignment?.integrationId,
                  reductions: {
                    BREAK_MEAL: 0,
                    BREAK_COFFEE: 0,
                    BREAK: 0,
                    AUTOMATIC_MEAL_BREAK_REDUCTION: 0,
                  },
                  atMealBreak: false,
                };
              }

              days[day][resource.user].assignmentHours[
                recordAssignmentId
              ].hours += hours;

              if (!days[day][resource.user].projectHours[record.project.id]) {
                days[day][resource.user].projectHours[record.project.id] = {
                  hours: 0,
                  projectName: record.project.name,
                  reductions: {
                    BREAK_MEAL: 0,
                    BREAK_COFFEE: 0,
                    BREAK: 0,
                    AUTOMATIC_MEAL_BREAK_REDUCTION: 0,
                  },
                };
              }

              days[day][resource.user].projectHours[record.project.id].hours +=
                hours;

              const recordAllowances = recordAllowancesGroupedByRecordId
                ? recordAllowancesGroupedByRecordId[record.id]
                : undefined;

              if (recordAllowances && recordAllowances.length > 0) {
                recordAllowances.forEach((recordAllowance) => {
                  const existingAddedAdditionalSalaryData =
                    resources[resource.user].additionalSalaries[
                      recordAllowance.salaryType
                    ];
                  const date = moment(record.croppedClockInAt).format('D.M.');

                  const fullDate = moment(record.croppedClockInAt).format();

                  resources[resource.user].seperateAdditionalSalaries.push({
                    unitCount: recordAllowance.unitCount,
                    date: fullDate,
                    salaryType: recordAllowance.salaryType,
                    jydacomProjectNumber: getJydacomProjectNumber(
                      record.project
                    ),
                    jydacomAssignmentCode: record.assignment?.integrationNumber,
                    jydacomAssignmentId: record.assignment?.integrationId,
                    jydacomAssignmentName: record.assignment?.integrationName,
                  });

                  if (existingAddedAdditionalSalaryData) {
                    existingAddedAdditionalSalaryData.unitCount += Number(
                      recordAllowance.unitCount
                    );
                    existingAddedAdditionalSalaryData.definedDates.push(date);
                    existingAddedAdditionalSalaryData.dayUnitCount[date] =
                      Number(recordAllowance.unitCount);
                  } else {
                    resources[resource.user].additionalSalaries[
                      recordAllowance.salaryType
                    ] = {
                      unitCount: Number(recordAllowance.unitCount),
                      definedDates: [date],
                      salaryType: recordAllowance.salaryType,
                      dayUnitCount: {
                        [date]: Number(recordAllowance.unitCount),
                      },
                      jydacomProjectNumber: getJydacomProjectNumber(
                        record.project
                      ),
                    };
                  }
                  if (
                    !resources[resource.user].additionalSalariesByProjectId[
                      recordAllowance.projectId
                    ]
                  ) {
                    resources[resource.user].additionalSalariesByProjectId[
                      recordAllowance.projectId
                    ] = {};
                  }

                  const existingAdditionalSalaryByProject =
                    resources[resource.user].additionalSalariesByProjectId[
                      recordAllowance.projectId
                    ][recordAllowance.salaryType];

                  if (existingAdditionalSalaryByProject) {
                    existingAdditionalSalaryByProject.unitCount += Number(
                      recordAllowance.unitCount
                    );
                    existingAdditionalSalaryByProject.definedDates.push(date);
                    existingAdditionalSalaryByProject.dayUnitCount[date] =
                      Number(recordAllowance.unitCount);
                  } else {
                    resources[resource.user].additionalSalariesByProjectId[
                      recordAllowance.projectId
                    ][recordAllowance.salaryType] = {
                      projectId: recordAllowance.projectId,
                      unitCount: Number(recordAllowance.unitCount),
                      definedDates: [date],
                      salaryType: recordAllowance.salaryType,
                      dayUnitCount: {
                        [date]: Number(recordAllowance.unitCount),
                      },
                    };
                  }
                });
              }

              if (
                !resources[resource.user].workedProjects.find(
                  (workedProject) =>
                    workedProject.projectId === record.project.id
                )
              ) {
                resources[resource.user].workedProjects.push({
                  projectName: record.project.name,
                  projectId: record.project.id,
                });
              }

              if (
                !resources[resource.user].workedAssignments.find(
                  (workedAssignment) =>
                    workedAssignment.assignmentId === recordAssignmentId
                )
              ) {
                resources[resource.user].workedAssignments.push({
                  assignmentName: `${
                    recordAssignment?.number
                      ? recordAssignment?.number + '. '
                      : ''
                  }${recordAssignment?.name || ''}`,
                  assignmentId: recordAssignmentId,
                  projectId: record.project.id,
                  jydacomAssignmentId: recordAssignment?.integrationId,
                  jydacomAssignmentCode: recordAssignment?.integrationNumber,
                });
              }

              const recordStartTime = moment(ci);
              const recordEndTime = moment(co);

              const timeframeStart = moment(i).set({
                hour: 11,
                minute: 0,
                second: 0,
              });
              const timeframeEnd = moment(i).set({
                hour: 11,
                minute: 30,
                second: 0,
              });

              const overlapsMealBreakTimeframe =
                recordStartTime.isBefore(timeframeEnd) &&
                recordEndTime.isAfter(timeframeStart);

              if (!resources[resource.user].dailyAssignmentsAtMealBreak[day]) {
                resources[resource.user].dailyAssignmentsAtMealBreak[day] = [];
              }

              if (!resources[resource.user].dailyProjectsAtMealBreak[day]) {
                resources[resource.user].dailyProjectsAtMealBreak[day] = [];
              }

              const dailyMealProjects =
                resources[resource.user].dailyProjectsAtMealBreak[day];

              const dailyAssignmentsAtMealTime =
                resources[resource.user].dailyAssignmentsAtMealBreak[day];

              if (overlapsMealBreakTimeframe) {
                // handle adding info that assignment active at meal time
                const assignmentAlreadyCounted =
                  dailyAssignmentsAtMealTime.includes(recordAssignmentId);

                if (!assignmentAlreadyCounted) {
                  days[day][resource.user].assignmentHours[
                    recordAssignmentId
                  ].atMealBreak = true;

                  dailyAssignmentsAtMealTime.push(recordAssignmentId);
                }

                const projectAlreadyCounted = dailyMealProjects.includes(
                  record.project.id
                );

                if (!projectAlreadyCounted) {
                  dailyMealProjects.push(record.project.id);
                }
              }

              if (thisDayHoursExceed6Hours) {
                if (dailyMealProjects.length > 0) {
                  // PROJECTS LOGIC, MAYBE NOT NEEDED FOR JYDACOM REPORT??

                  // Apply reduction to project hours
                  dailyMealProjects.forEach((projectId) => {
                    // Apply equal portion of reduction to each project
                    const reductionPerProject =
                      automaticMealBreakReductionLengthHours /
                      dailyMealProjects.length;

                    days[day][resource.user].projectHours[projectId].reductions[
                      'AUTOMATIC_MEAL_BREAK_REDUCTION'
                    ] = reductionPerProject;

                    //count reductions to total proejct reductions
                    const existingCountedReductionsForProject =
                      resources[resource.user].totals.reductionsByProject[
                        record.project.id
                      ];
                    if (!existingCountedReductionsForProject) {
                      resources[resource.user].totals.reductionsByProject[
                        record.project.id
                      ] = {
                        BREAK_MEAL: 0,
                        BREAK_COFFEE: 0,
                        BREAK: 0,
                        AUTOMATIC_MEAL_BREAK_REDUCTION: 0,
                      };
                    }

                    resources[resource.user].totals.reductionsByProject[
                      record.project.id
                    ]['AUTOMATIC_MEAL_BREAK_REDUCTION'] +=
                      automaticMealBreakReductionLengthHours;
                  });
                }

                if (dailyAssignmentsAtMealTime.length > 0) {
                  // if previously added information on record that is on meal time
                  dailyAssignmentsAtMealTime.forEach((assignmentId) => {
                    const reductionPerAssignment =
                      automaticMealBreakReductionLengthHours /
                      dailyAssignmentsAtMealTime.length;

                    days[day][resource.user].assignmentHours[
                      assignmentId
                    ].reductions['AUTOMATIC_MEAL_BREAK_REDUCTION'] =
                      reductionPerAssignment;
                  });
                } else {
                  // if no record previously set to meal time, then just reduce from current record / assignment

                  // check that no reductions were already made for this day
                  if (!isPreviouslyMadeAutomaticReductionsForDay) {
                    days[day][resource.user].assignmentHours[
                      recordAssignmentId
                    ].reductions['AUTOMATIC_MEAL_BREAK_REDUCTION'] =
                      automaticMealBreakReductionLengthHours;
                    const existingCountedReductionsForAssignment =
                      resources[resource.user].totals.reductionsByAssignment[
                        recordAssignmentId
                      ];
                    if (!existingCountedReductionsForAssignment) {
                      resources[resource.user].totals.reductionsByAssignment[
                        recordAssignmentId
                      ] = {
                        BREAK_MEAL: 0,
                        BREAK_COFFEE: 0,
                        BREAK: 0,
                        AUTOMATIC_MEAL_BREAK_REDUCTION: 0,
                      };
                    }

                    resources[resource.user].totals.reductionsByAssignment[
                      recordAssignmentId
                    ]['AUTOMATIC_MEAL_BREAK_REDUCTION'] +=
                      automaticMealBreakReductionLengthHours;
                  }
                }
              }
            } else if (record.type.includes('ABSENCE')) {
              // handle global resource additional salary data
              const existingAddedAdditionalSalaryData =
                resources[resource.user].additionalSalaries[record.type];
              const date = moment(record.croppedClockInAt).format('D.M.');
              const fullDate = moment(record.croppedClockInAt).format();

              const salaryType = record.subType
                ? record.subType
                : record.type === RECORD_TYPE.ABSENCE_SICK_LEAVE
                  ? 'SICK_LEAVE'
                  : 'HOLIDAY_PAY';

              resources[resource.user].seperateAdditionalSalaries.push({
                unitCount: 8,
                date: fullDate,
                salaryType,
                jydacomProjectNumber: getJydacomProjectNumber(record.project),
                baseType: 'ABSENCE',
              });

              if (existingAddedAdditionalSalaryData) {
                existingAddedAdditionalSalaryData.unitCount += 1;
                existingAddedAdditionalSalaryData.definedDates.push(date);
              } else {
                resources[resource.user].additionalSalaries[record.type] = {
                  unitCount: 1,
                  definedDates: [date],
                  salaryType,
                  baseType: 'ABSENCE',
                };
              }

              // handle project specific additional salary data adding
              if (
                !resources[resource.user].additionalSalariesByProjectId[
                  record.project.id
                ]
              ) {
                resources[resource.user].additionalSalariesByProjectId[
                  record.project.id
                ] = {};
              }

              const existingAdditionalSalaryByProject =
                resources[resource.user].additionalSalariesByProjectId[
                  record.project.id
                ][salaryType];

              if (existingAdditionalSalaryByProject) {
                existingAdditionalSalaryByProject.unitCount += 1;
                existingAdditionalSalaryByProject.definedDates.push(date);
              } else {
                resources[resource.user].additionalSalariesByProjectId[
                  record.project.id
                ][salaryType] = {
                  unitCount: 1,
                  definedDates: [date],
                  salaryType,
                  baseType: 'ABSENCE',
                  jydacomProjectNumber: getJydacomProjectNumber(record.project),
                };
              }

              if (
                !resources[resource.user].workedProjects.find(
                  (workedProject) =>
                    workedProject.projectId === record.project.id
                )
              ) {
                resources[resource.user].workedProjects.push({
                  projectName: record.project.name,
                  projectId: record.project.id,
                });
              }
            }
            resources[resource.user].totalHours += hours;
            resources[resource.user].totals[record.type] += hours;
          }
          i.add(1, 'days');
        }
      }
    });
    reportData['resources'] = resources;

    return reportData;
  };

  const runProcesses = () => {
    settings.processes.forEach((process) => {
      reportData = processes[process.type](reportData, process);
    });
    return reportData;
  };

  reportData = trimRecordsTime();
  reportData = initDays();
  reportData = baseHours();
  reportData = runProcesses();

  return reportData;
};

// used if record assignment main parent wants to be used
// const returnRecordMainParentAssignment = (record, assignments) => {
//   let effectiveAssignment = record.assignment;

//   const findParent = (parentId) => {
//     const parentAssignment = assignments.find(
//       (parent) => parent.id === parentId
//     );

//     if (parentAssignment) {
//       effectiveAssignment = parentAssignment;
//     }

//     if (parentAssignment.parent) {
//       findParent(parentAssignment);
//     }
//   };

//   if (record.assignment.parent) {
//     findParent(record.assignment.parent);
//   }

//   console.log('RETURNED ASSIGNMENT', effectiveAssignment);

//   return effectiveAssignment;
// };
